module.exports = "<a href=#><i class=\"fa q-link-icon q-marg-right-xs {%- toggleStatusIconClassName %}\"></i></a> <a href=#><i class=\"fa fa-pencil q-link-icon return-rule-edit-btn\"></i></a>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/returnsRules/html/rulesActionBtns.html
// module id = 1414
// module chunks = 1